export const versions = {
  version: "1.0.183",
  revision: "194acd8fb",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5101-g194acd8fb-dirty",
    hash: "g194acd8fb",
    distance: 5101,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5101-g194acd8fb-dirty",
    semverString: "1.0.183+5101.g194acd8fb.dirty"
  }
};
